export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <span className="text-xl font-heading text-background-50 mb-3 block">51每日大赛</span>
            <p className="text-sm text-background-400 leading-relaxed">
              51每日大赛是国内领先的娱乐八卦与争议事件聚合平台，每日更新最热吃瓜内容，涵盖明星塌房、综艺争议、网红翻车等热门话题，打造吃瓜爱好者的一站式爆料平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门专题', href: '#index' },
                { label: '最新爆料', href: '#cards' },
                { label: '吃瓜热度榜', href: '#ranking' },
                { label: '焦点追踪', href: '#carousel' },
                { label: '实时快讯', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '平台介绍', href: '#about' },
                { label: '常见问题', href: '#faq' },
                { label: '投稿爆料', href: '#contact' },
                { label: '移动端体验', href: '#app' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              我们期待与更多优质内容平台和媒体机构建立合作关系，共同为吃瓜爱好者提供更丰富的娱乐资讯体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-md bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-md bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-md bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51每日大赛. 本站内容仅供娱乐参考，不构成任何法律依据。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">爆料条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}